import { useEffect, useState } from 'react'

import BigNumber from 'bignumber.js'
import { Contract } from 'web3-eth-contract'
import { useActiveWeb3React } from '../hooks'

export const usePrice = (lpContract: Contract, baseTokenContract: Contract, quoteTokenContract: Contract) => {
  const [price, setPrice] = useState<BigNumber>()
  const { account } = useActiveWeb3React()

  useEffect(() => {
    ;(async function getPrice() {
      try {
        if (!account || !baseTokenContract) {
          setPrice(new BigNumber(0))
          return
        }
        if (baseTokenContract.options.address === quoteTokenContract.options.address) {
          setPrice(new BigNumber(1))
        } else {
          const baseTokenAmount = await baseTokenContract.methods.balanceOf(lpContract.options.address).call()
          const baseTokenDecimals = await baseTokenContract.methods.decimals().call()
          const quoteTokenAmount = await quoteTokenContract.methods.balanceOf(lpContract.options.address).call()
          const quoteTokenDecimals = await quoteTokenContract.methods.decimals().call()
          setPrice(
            new BigNumber(quoteTokenAmount)
              .times(new BigNumber(10).pow(baseTokenDecimals))
              .div(new BigNumber(10).pow(quoteTokenDecimals))
              .div(new BigNumber(baseTokenAmount))
          )
        }
      } catch (e) {
        console.error(e)
      }
    })()
  }, [account, lpContract, baseTokenContract, quoteTokenContract])

  return price
}

/**
 * 1 LP = X Token
 *   1 LP to Token = (1/lpTotalSupply) * tokenAmountWholeLP * 2
 * @param lpContract
 * @param tokenContract
 */
export const useLpTokenPrice = (lpContract: Contract, tokenContract: Contract) => {
  const [price, setPrice] = useState<BigNumber>()
  useEffect(() => {
    ;(async function getPrice() {
      try {
        if (lpContract.options.address === tokenContract.options.address) {
          setPrice(new BigNumber(1))
        } else {
          const tokenAmount = await tokenContract.methods.balanceOf(lpContract.options.address).call()
          const tokenDecimals = await tokenContract.methods.decimals().call()
          const lpTotalSupply = await lpContract.methods.totalSupply().call()
          const lpDecimals = await lpContract.methods.decimals().call()
          setPrice(
            new BigNumber(tokenAmount)
              .times(2)
              .times(new BigNumber(10).pow(lpDecimals))
              .div(new BigNumber(10).pow(tokenDecimals))
              .div(new BigNumber(lpTotalSupply))
          )
        }
      } catch (e) {
        console.error(e)
      }
    })()
  }, [lpContract, tokenContract])
  return price
}
